import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return <div className="page-shell not-found"><span>404</span><h1>That page isn’t in the directory.</h1><p>It may have moved, become private, or not exist yet.</p><Link className="button primary" to="/discover">Explore the ecosystem</Link></div>;
}
